<div class="safety-animation-container">
  <div class="title-section">
    <img [style.opacity]="safetyIconUrl ? '1' : '0'" [@fadeZoom]="animOut ? 'out':'in'" [src]="safetyIconUrl" alt=""/>
    <h2 [@fadeZoom]="animOut ? 'out':'in'">{{ 'LOCAL.SUBTYPE.' + currentNews.subType | uppercase | translate }}</h2>
  </div>

  <div [@fadeZoom]="animOut ? 'out':'in'" class="carousel-section" *ngIf="currentNews.images && currentNews.images.length > 0">
    <div class="carousel-wrapper">
      <img 
        [src]="previousImage" 
        alt="" 
        [class.fade-out]="isTransitioning"
        class="carousel-image previous-image"
        fallback="../assets/logo/local_thumbnail.png">
      <img 
        [src]="currentImage" 
        alt="" 
        [class.zoom-in]="isZooming"
        class="carousel-image current-image"
        fallback="../assets/logo/local_thumbnail.png">
    </div>
  </div>
</div>
